module.exports = __webpack_public_path__ + "img/unhcr-logo.0124e9c1.png";